import type { GeometryBuilder } from './geometry-builder';

/** Stylised, non-functional M4 silhouette, shared by every original operator. */
export function fieldRifle(g: GeometryBuilder, elite = false): void {
  const metal = 0x171c22,
    polymer = 0x252b31,
    rail = 0x343b42;
  g.box(-0.042, -0.025, -0.25, 0.084, 0.085, 0.31, metal);
  g.box(-0.033, -0.02, 0.045, 0.066, 0.07, 0.19, metal);
  g.box(-0.055, -0.065, 0.16, 0.11, 0.16, 0.16, polymer);
  g.box(-0.058, -0.07, 0.3, 0.116, 0.18, 0.025, metal);
  g.box(-0.031, -0.145, -0.005, 0.062, 0.13, 0.067, polymer);
  g.box(-0.03, -0.18, -0.165, 0.06, 0.17, 0.09, polymer);
  g.box(-0.032, -0.2, -0.2, 0.064, 0.065, 0.11, metal);
  g.box(-0.025, -0.005, -0.55, 0.05, 0.062, 0.32, polymer);
  g.box(-0.039, 0.047, -0.56, 0.078, 0.028, 0.33, rail);
  for (let i = 0; i < 8; i++) g.box(-0.04, 0.075, -0.52 + i * 0.04, 0.08, 0.012, 0.016, metal);
  g.box(-0.013, 0.019, -0.76, 0.026, 0.028, 0.23, metal);
  g.box(-0.021, 0.013, -0.81, 0.042, 0.04, 0.07, metal);
  // Both sights are mounted to the rail/barrel; no detached sight blocks.
  for (const zz of [-0.565, -0.075]) {
    g.box(-0.025, 0.047, zz, 0.05, 0.026, 0.04, rail);
    for (const xx of [-0.025, 0.016]) g.box(xx, 0.073, zz, 0.009, 0.05, 0.03, metal);
    g.box(-0.005, 0.073, zz + 0.01, 0.01, 0.035, 0.015, metal);
  }
  if (elite) {
    g.box(-0.035, 0.066, -0.21, 0.07, 0.028, 0.09, metal);
    g.box(-0.044, 0.094, -0.225, 0.088, 0.082, 0.13, polymer);
    g.box(-0.03, 0.104, -0.23, 0.06, 0.06, 0.009, 0x745b54);
    g.box(-0.034, 0.003, -1.0, 0.068, 0.06, 0.24, metal);
  }
}
